module.exports = __webpack_public_path__ + "img/Fraese.15db11a2.jpg";